export const TYPE = {
    Primary: 'primary',
    Secondary: 'secondary',
};
